import en from './en.mjs'

export default Object.freeze({
  ...en,
  'static.common.home': 'Happy Petsに戻る',
  'static.common.open': 'この体験を開く',
  'static.common.body': '自分のペースで体験し、見つけたことをHappy Petsのパートナーとの会話でさらに深めましょう。',
  'static.common.safetyreflection': '自己理解、振り返り、娯楽のための体験です。',
  'static.common.safetymedical': 'このセルフチェックは診断ではありません。健康や安全に不安がある場合は、資格を持つ専門家に相談してください。',
  'static.common.safetycareer': 'この体験は自己理解のためのもので、専門的なキャリア相談に代わるものではありません。',
  'static.common.safetyiq': '自己理解のための推理課題であり、現実のIQを確定するものではありません。',
  'static.feature.aicompanion.title': '毎日の暮らしと一緒に成長するAIパートナー',
  'static.feature.aicompanion.description': '日常の瞬間を覚え、軽く手伝い、ウィジェットでそばにいるバーチャルペットを育てます。',
  'static.feature.aitarot.title': 'やさしい振り返りのためのAIタロット',
  'static.feature.aitarot.description': 'タロットカードを、振り返りや視点の変化、次の一歩のための想像力豊かなヒントとして使います。',
  'static.feature.mbti.title': 'AIパートナーと探るMBTI性格テスト',
  'static.feature.mbti.description': '性格の好み、コミュニケーション、強み、成長の方向をAIパートナーと一緒に探ります。',
  'static.feature.mindscope.title': 'Mind Scopeの自己発見テスト',
  'static.feature.mindscope.description': '性格、推理、キャリア、関係、感情のテストを一か所で楽しめます。',
  'static.feature.sbti.title': '楽しく自己発見できるSBTI性格テスト',
  'static.feature.sbti.description': '5つの楽しい視点から、自分の交流スタイルを見つけます。',
  'static.feature.funny.title': '友だちと共有できる面白い性格テスト',
  'static.feature.funny.description': '気軽な性格体験を試し、結果を友だちと比べましょう。',
  'static.feature.iq.title': '認知課題としてのIQ推理テスト',
  'static.feature.iq.description': '視覚的・非言語的なパターンを解く、構造化された推理課題です。',
  'static.feature.scl90.title': '個人の振り返りのためのSCL-90セルフチェック',
  'static.feature.scl90.description': '構造化された項目で傾向に気づき、必要なら専門家への質問を整理します。',
  'static.feature.holland.title': '自己理解のためのホランド職業興味テスト',
  'static.feature.holland.description': '6つの興味領域から、自分に合いそうな活動や仕事環境を振り返ります。',
  'static.feature.psychage.title': '振り返りのための心理年齢テスト',
  'static.feature.psychage.description': '楽しい質問で、考え方、習慣、日常への向き合い方を振り返ります。',
  'static.feature.attachment.title': '関係を振り返る愛着スタイルテスト',
  'static.feature.attachment.description': '親密さ、信頼、安心感、自立について振り返ります。',
  'static.feature.temperament.title': '自己発見のための気質テスト',
  'static.feature.temperament.description': '感情の強さ、ペース、適応性、日常の反応を探ります。',
  'static.feature.eq.title': '振り返りのための感情知能テスト',
  'static.feature.eq.description': '感情の気づき、調整、共感、コミュニケーションを振り返ります。',
  'static.help.title': 'Happy Petsヘルプセンター',
  'static.help.description': '共同育成、招待、広告、ペット管理、よくある質問を案内します。',
  'static.help.intro': 'Happy Petsのよくある質問をすぐに確認できます。',
  'static.help.sections': [
    { title: '友だちと一緒にペットを育てたい。', body: 'Pet Farm、ペットメニュー、右上の操作メニューから招待できます。友だちは共有リンク、共同育成コード、アプリ内リクエストで参加できます。' },
    { title: '広告動画が読み込めません。', body: '通信を確認し、アプリを再起動してキャッシュを削除し、最新版へ更新してください。続く場合はサポートへ連絡してください。' },
    { title: '共同育成とは何ですか？', body: '複数のユーザーが同じバーチャルペットを世話し、役割や交流、特別な報酬を共有できる機能です。' },
    { title: 'ペットの名前や呼び名を変えるには？', body: 'プロフィールから設定を開き、ペット名または飼い主名を編集して保存します。変更に待ち時間がある場合があります。' }
  ],
  'static.privacy.title': 'Happy Petsプライバシーポリシー',
  'static.privacy.description': 'Happy Petsが収集する情報、利用と保護の方法、お問い合わせ先を説明します。',
  'static.privacy.effective': '発効日：2025年4月7日',
  'static.privacy.intro': 'Happy Petsはプライバシーを大切にします。本ポリシーはアプリ、サービス、ウェブサイト利用時の情報の取り扱いを説明します。',
  'static.privacy.sections': [
    { title: '1. 収集する情報', body: '給餌や進行状況などの操作データ、端末と利用状況の分析、任意で送信された連絡先やフィードバックを収集する場合があります。' },
    { title: '2. 利用目的', body: 'ペット育成とウィジェット機能、品質改善、問題修正、サポート、コンテンツの最適化に利用します。' },
    { title: '3. 情報の共有', body: '個人情報を販売しません。サービスの運営・維持に必要な場合に限り、適切な保護義務の下で信頼できる事業者と共有します。' },
    { title: '4. セキュリティ', body: '紛失、盗難、不正アクセスを防ぐための合理的な保護策を講じます。' },
    { title: '5. 利用者の権利', body: '情報の開示・訂正を求め、happyscratchpad@gmail.comへ連絡してアカウントと関連データの削除を申請できます。' },
    { title: '6. 子どものプライバシー', body: '保護者の同意なく13歳未満の子どもを対象とするサービスではありません。' },
    { title: '7. 変更', body: '本ポリシーを更新する場合があり、重要な変更は利用者へ通知します。' },
    { title: '8. お問い合わせ', body: 'プライバシーに関する質問はhappyscratchpad@gmail.comへお送りください。' }
  ],
  'static.terms.title': 'Happy Pets利用規約',
  'static.terms.description': 'アカウント、仮想アイテム、ウィジェット、共同育成、適切な利用に関する規約です。',
  'static.terms.effective': '発効日：2025年4月7日',
  'static.terms.intro': '本規約はHappy Petsへのアクセスと利用に適用されます。サービス利用により本規約に同意したものとみなします。',
  'static.terms.sections': [
    { title: '1. サービス概要', body: 'Happy Petsは、仮想ペットの育成、給餌、孵化、共同育成、ウィジェットなどを提供する娯楽サービスです。' },
    { title: '2. アカウント', body: '一部機能にはアカウントが必要です。正確な情報を提供し、安全に管理してください。' },
    { title: '3. 仮想アイテム', body: '仮想ペット、アイテム、報酬は譲渡できず、現実の金銭価値を持ちません。' },
    { title: '4. 利用行為', body: '違法利用、サービスや他の利用者への妨害、攻撃的・脅迫的・不適切な内容の共有は禁止します。' },
    { title: '5. 共同育成', body: '友だちを招待し、ペットの世話に関する役割と利益を共有できます。' },
    { title: '6. ウィジェット', body: 'ホーム画面にペットを追加し、給餌、気分確認、交流など利用可能な機能を使えます。' },
    { title: '7. 利用停止', body: '違反や不正利用があった場合、アクセスを停止または終了できます。' },
    { title: '8. 責任制限', body: 'サービスは現状有姿で提供されます。法令の範囲内で、利用に関連する損失について責任を負いません。' },
    { title: '9. 更新', body: '機能、内容、規約を更新する場合があります。変更後の継続利用は更新規約への同意を意味します。' },
    { title: '10. お問い合わせ', body: '質問はhappyscratchpad@gmail.comへお送りください。' }
  ]
})
